import { createFileRoute, redirect } from "@tanstack/react-router";

// The trends page became the "Tendance" sort of the gift ideas catalogue: one page, not two
// competing for the same search.
export const Route = createFileRoute("/tendances")({
  staticData: { ssr: true },
  beforeLoad: () => {
    // 301: search engines move the old page's standing to the new one.
    throw redirect({
      to: "/idees-cadeaux",
      search: { sort: "trend" },
      replace: true,
      statusCode: 301,
    });
  },
});
